import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { BoxForm, Select, TextField } from 'components/Form'
import Paper from 'components/Paper'
import { KNOWLEDGE_BASE } from 'features/globalSetup/constants'
import { UserWorkspaceRole, userWorkspaceRoleOptions } from 'features/user'
import { Schema } from './schema'

export const Form = (): JSX.Element => {
  const { t } = useTranslation(['features/globalSetup', 'common'])
  const { control } = useFormContext<Schema>()

  return (
    <Paper>
      <BoxForm>
        <TextField
          control={control}
          label={t('general.userManagement.common.email.label')}
          name='email'
          placeholder={t('general.userManagement.common.email.placeholder')}
        />

        <Select<Schema, UserWorkspaceRole>
          control={control}
          label={t('general.userManagement.common.role.label')}
          name='role'
          options={userWorkspaceRoleOptions()}
          tooltip={{
            content: t('general.userManagement.common.role.tooltip'),
            link: {
              title: t('common:learnMore'),
              url: KNOWLEDGE_BASE.USER_MANAGEMENT,
            },
          }}
        />
      </BoxForm>
    </Paper>
  )
}
